import { ApiService } from "./../../services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { Component, OnInit, ViewChild } from "@angular/core";
import { CompanyNews } from "src/app/models/company-news";
declare const TradingView: any;
import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ChartComponent,
  ApexXAxis,
  ApexDataLabels,
  ApexAxisChartSeries,
  ApexFill,
  ApexStroke,
  ApexGrid,
  ApexYAxis,
} from "ng-apexcharts";
import { h } from "docking-egid/dist/types/stencil-public-runtime";

export type ChartOptions = {
  series:ApexAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels?: any;
  dataLabels?: ApexDataLabels;
  xaxis?: ApexXAxis;
  yaxis?: ApexYAxis;
  grid?: ApexGrid;
  fill?: ApexFill;
  stroke?:ApexStroke;
};
@Component({
  selector: "app-local-market",
  templateUrl: "./local-market.component.html",
  styleUrls: ["./local-market.component.scss"],
})
export class LocalMarketComponent implements OnInit {
  news: CompanyNews[];
  investorTradingData: any;
  isDarkTheme: boolean;

  @ViewChild("chart") chart: ChartComponent;
  public individualChartOptions: Partial<ChartOptions>;
  public investorChartOptions: Partial<ChartOptions>;
  top5Best: any[];
  top5Worst: any[];
  colorScheme = ["#008080", "#f4a261", "#216d95"];
  fetchInvestorTypes: any;
  fetchInvestorTypeIndividual: any;
  activeEgx = "EGX30";
  investorSummary: any[];
  constructor(
    public translate: TranslateService,
    private apiService: ApiService
  ) {
    this.apiService.fetchMarketNews().subscribe((res) => {
      this.news = res;
    });

    this.apiService.fetchTop5Best().subscribe((res) => {
      this.top5Best = res;
    });

    this.apiService.fetchTop5Worst().subscribe((res) => (this.top5Worst = res));
  }

  ngOnInit(): void {
    this.isDarkTheme =
    localStorage.getItem("darktheme") == "dark" ? true : false;
    this.fetchEgx();
    this.apiService.fetchAllInvestor().subscribe((res) => {
    this.investorSummary = res["Index"];
    });
    this.ApiFetchInvestorTypeIndividual();
    this.ApiFetchInvestorTypes();

  }

  slideConfig = {
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    rtl:this.translate.currentLang == "en"? false : true,
    adaptiveHeight: true, // Add this
    infinite: false, // Add this to prevent cloning issues
  };
  fetchEgx() {
    new TradingView.widget({
      width: "100%",
      height: 400,
      symbol: this.activeEgx,
      // interval: "D",
      timezone: "Africa/Cairo",
      theme: this.isDarkTheme ? "Dark" : "Light",
      style: "3",
      locale: this.translate.currentLang == "ar" ? "ar_AE" : "en",
      // toolbar_bg: "#f1f3f6",
      // enable_publishing: false,
      // withdateranges: true,
      // range: "ytd",
      hide_side_toolbar: true,
      hide_top_toolbar: true,
      // allow_symbol_change: true,
      // show_popup_button: true,
      // popup_width: "1000",
      // popup_height: "650",
      // no_referral_id: true,
      container_id: "tradingview_bac65",
    });
  }
      ApiFetchInvestorTypes(){
      this.apiService.fetchInvestorTypes().subscribe({
      next: (res) => {
        this.fetchInvestorTypes = res;
      },
      error: (error) => {
      },
      complete: () => {
        this.initChartInvestorTypes();
      }
    });
        }
    ApiFetchInvestorTypeIndividual(){
      this.apiService.fetchInvestorTypeIndividual().subscribe({
      next: (res) => {
        this.fetchInvestorTypeIndividual = res;
      },
      error: (error) => {
      },
      complete: () => {
        this.initChartInvestorTypeIndividual();
      }
    });
    }

      initChartInvestorTypeIndividual()
      {
        if(this.fetchInvestorTypeIndividual)
        {
          this.individualChartOptions = {
            series: [this.fetchInvestorTypeIndividual["Individuals"].Value, this.fetchInvestorTypeIndividual["Instituitions"].Value],
            chart: {
              width: "100%",
              type: "pie",
            },
            labels:
              this.translate.currentLang == "en"
                ? [
                    this.fetchInvestorTypeIndividual["Individuals"]["Label_En"],
                    this.fetchInvestorTypeIndividual["Instituitions"]["Label_En"],
                  ]
                : [
                    this.fetchInvestorTypeIndividual["Individuals"]["Label_Ar"],
                    this.fetchInvestorTypeIndividual["Instituitions"]["Label_Ar"],
                  ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200,
                    height: 300,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          };
        }
        else{
        }

      }
      initChartInvestorTypes()

      {

        if(this.fetchInvestorTypes)
        {
          this.investorChartOptions = {
            series: [this.fetchInvestorTypes[0].TOTAL_PERC, this.fetchInvestorTypes[1].TOTAL_PERC, this.fetchInvestorTypes[2].TOTAL_PERC],
            chart: {
              width: "100%",
              type: "pie",
            },
            labels:
              this.translate.currentLang == "en"
                ? [
                    this.fetchInvestorTypes[0].SELL_CLIENT_EN,
                    this.fetchInvestorTypes[1].SELL_CLIENT_EN,
                    this.fetchInvestorTypes[2].SELL_CLIENT_EN,
                  ]
                : [this.fetchInvestorTypes[0].SELL_CLIENT, this.fetchInvestorTypes[1].SELL_CLIENT, this.fetchInvestorTypes[2].SELL_CLIENT],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200,
                  },
                  legend: {
                    position: "bottom",
                  },
                },
              },
            ],
          };
        }
        else{
        }
      }
    }
